<template>
  <div id="wrapper">
    <top-bar :game-status="gameStatus"> </top-bar>
    <div class="flexbox main-content">
      <dead-hall team-name="red" :losts="redDeadHall"> </dead-hall>
      <game-board :tile-map="tileMap"> </game-board>
      <dead-hall team-name="blue" :losts="blueDeadHall"> </dead-hall>
    </div>
    <unit-selector :units="game.currentPlacingUnits"> </unit-selector>
    <teams-selector> </teams-selector>
    <unload-selector v-if="showUnloadSelector" :unload-units="unloadUnits"> </unload-selector>
    <button @click="toggleNestedVehicles()"> Nested vehicles: {{ game.allowNestedVehicles ? 'On' : 'Off'}} </button>
    <div style="display:inline;" v-for="i in game.numOfScenarios" :key="i">
      <button @click="game.saveScenario(i)"> Save Scenario {{ i }} </button>
      <button @click="game.loadScenario(i)"> Load Scenario {{ i }} </button>
    </div>
    <button @click="game.reset()"> Reset </button>
  </div>
</template>

<script>
import GameBoard from './Sandbox/GameBoard.vue'
import DeadHall from './Sandbox/DeadHall.vue';
import UnitSelector from './Sandbox/UnitSelector.vue';
import TeamsSelector from './Sandbox/TeamsSelector.vue';
import {board, areas, gameStages} from '../scripts/GameVariables';
import Game from '../scripts/Sandbox';
import UnloadSelector from './Sandbox/UnloadSelector.vue';
import TopBar from './Sandbox/TopBar.vue';

export default {
  components: {
    GameBoard, DeadHall,
    UnitSelector, TeamsSelector,
    UnloadSelector, TopBar
  },
  data() {
    let gameObj = new Game();
    return{
      gameStatus: {
        gameStage: gameStages.prepStage,
        turnPlayer: 'red',
        turnNumber: 0
      },
      game: gameObj,
      tileMap: gameObj.tileMap,
      groundTypes: areas,
      board: board,
      tileMapUpdater: false,
      redDeadHall: [],
      blueDeadHall: [],
      selectMode: false,
      unloadUnits: [],
    };
  },
  provide() {
    return {
      game: this.game,
      tileMap: this.tileMap,
      groundTypes: this.groundTypes,
      onTileClick: this.game.onTileClick,
      setPlacingUnit: this.setPlacingUnit,
      tileMapUpdater: this.tileMapUpdater,
      selectMode: () => this.selectMode,
    };
  },
  computed: {
    showUnloadSelector(){
      if(this.selectMode){
        const unit = this.game.getUnitByLocation(...this.game.selectedUnitCords);
        return (unit.isVehicle || (unit.type === 'troop' && unit.isCarryingFlag));
      }
      return false;
    },
  },
  methods: {
    toggleNestedVehicles(){
      this.game.allowNestedVehicles = !this.game.allowNestedVehicles;
    },
    updateTileMap(tileMap){
      this.tileMap = [...tileMap];
    },
    updateDeadHall(team, hall){
      if(team === 'red'){
        this.redDeadHall = [...hall];
      }
      else if(team === 'blue'){
        this.blueDeadHall = [...hall];
      }
    },
    updateSelectMode(value){
      this.selectMode = value;
    },
    updateUnloadUnits(unloadUnits){
      this.unloadUnits = [...unloadUnits];
    },
    updateGameStatus(gameStatus){
      this.gameStatus = {...gameStatus};
    },
  },
  created() {
    this.game.updaters.tileMap = this.updateTileMap;
    this.game.updaters.deadHall = this.updateDeadHall;
    this.game.updaters.selectMode = this.updateSelectMode;
    this.game.updaters.unloadUnits = this.updateUnloadUnits;
    this.game.updaters.gameStatus = this.updateGameStatus;
  }
};
</script>

<style scoped>
#wrapper{
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}
.main-content{
  margin-bottom: 8px;
}
</style>
